<template>
  <main id="layout-main">
    <warehouse-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" />
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('layout.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('layout.layoutsSummary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <add-dialog />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>
<script>

import WarehouseList from '@/components/WarehouseList/WarehouseList';
import SearchFilter from './SearchFilters';
import SearchSummary from './SearchSummary';
import AddDialog from './components/AddDialog';

export default {
  name: 'Layout',
  components: {
    SearchFilter,
    SearchSummary,
    AddDialog,
    WarehouseList
  },
  data() {
    return {
      actionMountChained: ['layout/setDefaultFilters'],
      actionSelectChained: ['layout/search']
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
#layout-main {
  .default-section-title {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
